import { isAfter, parseISO } from 'date-fns';
import { toDisplayedDayStart } from '@/common/utils/dateFormats';

export type GoverningDeadline = {
  deadline: string | null | undefined;
  sourceItemName: string | null | undefined;
};

export const getIsAtRisk = ({
  latestFinish,
  planEndDate,
}: {
  latestFinish: string;
  planEndDate: string;
}) => {
  const latestFinishIso = parseISO(latestFinish);
  const planEnd = parseISO(planEndDate);

  return isAfter(latestFinishIso, planEnd);
};

// Deadlines and forecasts carry a time of day, but both the rule and the UI are
// day-granular: a forecast finishing at 17:00 on the deadline's own date is not
// late. Comparing raw instants would flag it and then render "past its {date}
// deadline" against that very date.
export const getIsDeadlineAtRisk = ({
  forecastedFinish,
  deadline,
}: {
  forecastedFinish: string | null | undefined;
  deadline: string | null | undefined;
}): boolean => {
  if (!forecastedFinish || !deadline) return false;

  const forecastDay = toDisplayedDayStart(forecastedFinish);
  const deadlineDay = toDisplayedDayStart(deadline);
  if (!forecastDay || !deadlineDay) return false;

  return isAfter(forecastDay, deadlineDay);
};

export const getGoverningDeadline = ({
  ownDeadline,
  ancestorDeadline,
  ancestorSourceItemName,
}: {
  ownDeadline: string | null | undefined;
  ancestorDeadline: string | null | undefined;
  ancestorSourceItemName: string | null | undefined;
}): GoverningDeadline => {
  if (!ancestorDeadline) return { deadline: ownDeadline, sourceItemName: null };
  const ancestorDay = toDisplayedDayStart(ancestorDeadline);
  const ownDay = toDisplayedDayStart(ownDeadline);
  if (!ownDay || !ancestorDay || !isAfter(ancestorDay, ownDay)) {
    return { deadline: ancestorDeadline, sourceItemName: ancestorSourceItemName ?? null };
  }
  return { deadline: ownDeadline, sourceItemName: null };
};
